module.exports = __webpack_public_path__ + "c_static/img/buyer_notification_msg_default.e786e69.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/img/buyer_notification_msg_default.png
// module id = 3mrt
// module chunks = 33